export default __webpack_public_path__ + "static/media/bg2.51f56adf.png";